'use client';

import * as React from 'react';
import { buttonVariants, P } from '@paypoteam/ui-components';
import { CaretRight } from '@phosphor-icons/react';
import Link from 'next/link';

import {cn} from "@/lib/utils";

import { LocalImage } from '@/components/atoms/LocalImage';
import Section from '@/components/layout/Section';
import type { InfoSectionType } from '@/components/sections/InfoSection/InfoSection.types';

const InfoSection = React.forwardRef<HTMLDivElement, InfoSectionType>(
    ({ config, ...props }, ref) => (
        <Section
            ref={ref}
            {...props}
        >
            <div className="flex flex-wrap justify-between md:flex-nowrap md:gap-4 lg:gap-16">
                <div className="w-auto">
                    <P className="text-grey-600">
                        {config.title}

                        <a
                            href={config.titleCta.href}
                            target="_blank"
                            className={cn(buttonVariants({
                                variant: 'ghost'
                            }), 'ml-1 !inline-block w-[40px] font-semibold')}
                            data-test-id={config.titleCta['data-test-id']}
                        >
                            {config.titleCta.children}
                        </a>
                    </P>

                    <a
                        href={config.cta.href}
                        target="_blank"
                        className={cn(buttonVariants({
                            variant: 'ghost',
                        }),'mt-8 w-fit justify-start lg:mt-6' )}
                        data-test-id={config.cta['data-test-id']}
                    >
                        {config.cta.children}

                        <CaretRight
                            weight="bold"
                            className="ml-1"
                        />
                    </a>
                </div>

                <div className="flex w-full shrink-0 justify-center gap-6 md:w-auto md:justify-start">
                    {config.images.map(
                        ({ id, src, alt, width, height, link, ...props }) => (
                            // @ts-ignore @TODO check onToggle method
                            <Link
                                key={id}
                                href={link}
                                target="_blank"
                                className="mt-8 md:mt-0"
                                {...props}
                            >
                                <LocalImage
                                    width={width}
                                    height={height}
                                    src={src}
                                    alt={alt}
                                />
                            </Link>
                        ),
                    )}
                </div>
            </div>
        </Section>
    ),
);

export default InfoSection;
